module.exports = __webpack_public_path__ + "static/media/dt_kelly_benoit_bird.6e109940.png";